// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.styles_appDiv__b3idb
{
  width: 100%;
  height: 100%;
  margin: 0;
  background-color:"black";
  border-width: var(--debug-border-app-width);
  border-style: var(--debug-border-style);
  color: white;
  text-align: center;
  overflow: hide;


}

.styles_appDivTop__eAbwf
{
  width: 100%;
  height: 78px;
  display: flex;
  flex-direction: row;
  margin-top: 5px;
  border-color: yellow;
  border-width: var(--debug-border-app-width);
  border-style: var(--debug-border-style);
}


.styles_appDivLogoFtva__9jDiS
{
  position: relative;
  margin-left: 5px;
  top:0px;
  padding-top: 5px;
  height: 100%;
  width: 200px;
  border-color: blue;
  background-color: var(--panel-color-background-default);
  border-radius: 5px;
  border-color: var(--panel-color-border);
  border-width: var(--panel-width-border);

}

.styles_appDivLanguage__xY3if
{
  height: 100%;
  width: 50;
  border-color: blue;
  background-color: var(--panel-color-background-default);
  border-radius: 5px;
  border-color: var(--panel-color-border);
  border-width: var(--panel-width-border);

}


.styles_appDivLogo__H44DO
{
  height: 100%;
  width: 350px;
  border-color: blue;
  background-color: var(--panel-color-background-default);
  border-radius: 5px;
  border-color: var(--panel-color-border);
  border-width: var(--panel-width-border);
  top: 0px;
  padding-top: 10px;

}



.styles_appDivProject__NCHS7
{
  margin-left: 5px;
  margin-right: 5px;

  overflow: hidden;
  
  height: 100%;
  width: calc(100% - 520px);
  background-color: var(--panel-color-background-default);
  border-radius: 5px;
  border-color: var(--panel-color-border);
  border-width: var(--panel-width-border);
  border-style: var(--debug-border-style);

}

.styles_appDivProjectLeft__icS3-
{
  float: left;
  background-color: transparent;
  padding-top: 10px;
  top: 0px;
  text-align: center;
  font-size: small;
  
  width:50%;
  height: 100%;
  

}
.styles_appDivProjectRight__MvNW8
{
  float: left;
  
  padding-top: 10px;
  width:50%;
  height: 100%;
  background-color:transparent;
  
}

.styles_appDivUser__PE-Wr
{
  margin-left: 5px;
  
  height: 100%;
  width: 100px;
  text-align: center;
  background-color: var(--panel-color-background-default);
  border-radius: 5px;
  border-color: var(--panel-color-border);
  border-width: var(--panel-width-border);
  border-style: var(--debug-border-style);
  

}


.styles_appDivToolsBar__QVBWe
{
  height: 42px;
  width: 99.5%;
  padding-top: 0px;
  background-color: var(--toolsbar-backcolor);
  border-radius: 5px;
  border-color: var(--panel-color-border);
  border-width: var(--panel-width-border);
  border-style: var(--debug-border-style);

}


.styles_appDivBody__YoBDR
{
  width: 100%;
  height: calc(100% - 128px);
  
  border-width: var(--debug-border-app-width);
  border-style: var(--debug-border-style);
  
}


.styles_appPanelsContainer__68vyI {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    margin-left: 5px;
    }
.styles_appPanelsContainerExport__63o3T {
    width: 100%;
    height: calc(100% - 30px);
    display: flex;
    flex-direction: column;
    gap: 1rem;
    margin-left: 5px;
    }



.styles_appPanelsContainerRow__MYVft {
  width: 100%;
  height: 100%;
  
  overflow: hidden;
  }


  .styles_appBlockContainer__KEOyW {
    font-size: 12px;
    background-color: transparent;
    width: 100%;
    
  }

  .styles_appPanel__Sn\\+bQ {
    display: flex;
    flex-direction: column;
  }

  .styles_appPanelBorder__NR8hr {
    display: flex;
    flex-direction: column;
    border-color: var(--panel-color-border);
    border-width: var(--panel-width-border);
    border-radius: 8px;
    border-style: solid;
    margin: 10px;
    background-color: var(--panel-color-background-default);
    }


  .styles_ResizeHandleOuter__KzoO5 {
    flex: 0 0 0.2em;
    position: relative;
    outline: none;
  
    --background-color: transparent;
  }
  .styles_ResizeHandleOuter__KzoO5[data-resize-handle-active] {
    --background-color: var(--color-solid-resize-bar-handle);
  }
  
  .styles_ResizeHandleInner__LZCFZ {
    position: absolute;
    top: 0.25em;
    bottom: 0.25em;
    left: 0.25em;
    right: 0.25em;
    border-radius: 0.25em;
    background-color: white;
    transition: background-color 0.2s linear;
  }
  
  .styles_apptitleexport__KPTWq
  {
    background-color: #000050;
    padding-bottom: 8px;
    color: white;
    margin-bottom: 10px;
  }


  .styles_apptitletimeline__Ad8sO
  {
    font-size: 10px;
    font-weight: bold;
    padding-left: 8px;
    padding-right: 8px;
    border-radius: 3px;
    color: black;
    background-color: var(--default-icon-color);
  }`, "",{"version":3,"sources":["webpack://./src/applications/appstyles/styles.module.css"],"names":[],"mappings":";AACA;;EAEE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,wBAAwB;EACxB,2CAA2C;EAC3C,uCAAuC;EACvC,YAAY;EACZ,kBAAkB;EAClB,cAAc;;;AAGhB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,2CAA2C;EAC3C,uCAAuC;AACzC;;;AAGA;;EAEE,kBAAkB;EAClB,gBAAgB;EAChB,OAAO;EACP,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,uDAAuD;EACvD,kBAAkB;EAClB,uCAAuC;EACvC,uCAAuC;;AAEzC;;AAEA;;EAEE,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,uDAAuD;EACvD,kBAAkB;EAClB,uCAAuC;EACvC,uCAAuC;;AAEzC;;;AAGA;;EAEE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,uDAAuD;EACvD,kBAAkB;EAClB,uCAAuC;EACvC,uCAAuC;EACvC,QAAQ;EACR,iBAAiB;;AAEnB;;;;AAIA;;EAEE,gBAAgB;EAChB,iBAAiB;;EAEjB,gBAAgB;;EAEhB,YAAY;EACZ,yBAAyB;EACzB,uDAAuD;EACvD,kBAAkB;EAClB,uCAAuC;EACvC,uCAAuC;EACvC,uCAAuC;;AAEzC;;AAEA;;EAEE,WAAW;EACX,6BAA6B;EAC7B,iBAAiB;EACjB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;;EAEhB,SAAS;EACT,YAAY;;;AAGd;AACA;;EAEE,WAAW;;EAEX,iBAAiB;EACjB,SAAS;EACT,YAAY;EACZ,4BAA4B;;AAE9B;;AAEA;;EAEE,gBAAgB;;EAEhB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,uDAAuD;EACvD,kBAAkB;EAClB,uCAAuC;EACvC,uCAAuC;EACvC,uCAAuC;;;AAGzC;;;AAGA;;EAEE,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,2CAA2C;EAC3C,kBAAkB;EAClB,uCAAuC;EACvC,uCAAuC;EACvC,uCAAuC;;AAEzC;;;AAGA;;EAEE,WAAW;EACX,0BAA0B;;EAE1B,2CAA2C;EAC3C,uCAAuC;;AAEzC;;;AAGA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,gBAAgB;IAChB;AACJ;IACI,WAAW;IACX,yBAAyB;IACzB,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,gBAAgB;IAChB;;;;AAIJ;EACE,WAAW;EACX,YAAY;;EAEZ,gBAAgB;EAChB;;;EAGA;IACE,eAAe;IACf,6BAA6B;IAC7B,WAAW;;EAEb;;EAEA;IACE,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,uCAAuC;IACvC,uCAAuC;IACvC,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,uDAAuD;IACvD;;;EAGF;IACE,eAAe;IACf,kBAAkB;IAClB,aAAa;;IAEb,+BAA+B;EACjC;EACA;IACE,wDAAwD;EAC1D;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,cAAc;IACd,YAAY;IACZ,aAAa;IACb,qBAAqB;IACrB,uBAAuB;IACvB,wCAAwC;EAC1C;;EAEA;;IAEE,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;IACZ,mBAAmB;EACrB;;;EAGA;;IAEE,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,2CAA2C;EAC7C","sourcesContent":["\n.appDiv\n{\n  width: 100%;\n  height: 100%;\n  margin: 0;\n  background-color:\"black\";\n  border-width: var(--debug-border-app-width);\n  border-style: var(--debug-border-style);\n  color: white;\n  text-align: center;\n  overflow: hide;\n\n\n}\n\n.appDivTop\n{\n  width: 100%;\n  height: 78px;\n  display: flex;\n  flex-direction: row;\n  margin-top: 5px;\n  border-color: yellow;\n  border-width: var(--debug-border-app-width);\n  border-style: var(--debug-border-style);\n}\n\n\n.appDivLogoFtva\n{\n  position: relative;\n  margin-left: 5px;\n  top:0px;\n  padding-top: 5px;\n  height: 100%;\n  width: 200px;\n  border-color: blue;\n  background-color: var(--panel-color-background-default);\n  border-radius: 5px;\n  border-color: var(--panel-color-border);\n  border-width: var(--panel-width-border);\n\n}\n\n.appDivLanguage\n{\n  height: 100%;\n  width: 50;\n  border-color: blue;\n  background-color: var(--panel-color-background-default);\n  border-radius: 5px;\n  border-color: var(--panel-color-border);\n  border-width: var(--panel-width-border);\n\n}\n\n\n.appDivLogo\n{\n  height: 100%;\n  width: 350px;\n  border-color: blue;\n  background-color: var(--panel-color-background-default);\n  border-radius: 5px;\n  border-color: var(--panel-color-border);\n  border-width: var(--panel-width-border);\n  top: 0px;\n  padding-top: 10px;\n\n}\n\n\n\n.appDivProject\n{\n  margin-left: 5px;\n  margin-right: 5px;\n\n  overflow: hidden;\n  \n  height: 100%;\n  width: calc(100% - 520px);\n  background-color: var(--panel-color-background-default);\n  border-radius: 5px;\n  border-color: var(--panel-color-border);\n  border-width: var(--panel-width-border);\n  border-style: var(--debug-border-style);\n\n}\n\n.appDivProjectLeft\n{\n  float: left;\n  background-color: transparent;\n  padding-top: 10px;\n  top: 0px;\n  text-align: center;\n  font-size: small;\n  \n  width:50%;\n  height: 100%;\n  \n\n}\n.appDivProjectRight\n{\n  float: left;\n  \n  padding-top: 10px;\n  width:50%;\n  height: 100%;\n  background-color:transparent;\n  \n}\n\n.appDivUser\n{\n  margin-left: 5px;\n  \n  height: 100%;\n  width: 100px;\n  text-align: center;\n  background-color: var(--panel-color-background-default);\n  border-radius: 5px;\n  border-color: var(--panel-color-border);\n  border-width: var(--panel-width-border);\n  border-style: var(--debug-border-style);\n  \n\n}\n\n\n.appDivToolsBar\n{\n  height: 42px;\n  width: 99.5%;\n  padding-top: 0px;\n  background-color: var(--toolsbar-backcolor);\n  border-radius: 5px;\n  border-color: var(--panel-color-border);\n  border-width: var(--panel-width-border);\n  border-style: var(--debug-border-style);\n\n}\n\n\n.appDivBody\n{\n  width: 100%;\n  height: calc(100% - 128px);\n  \n  border-width: var(--debug-border-app-width);\n  border-style: var(--debug-border-style);\n  \n}\n\n\n.appPanelsContainer {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n    margin-left: 5px;\n    }\n.appPanelsContainerExport {\n    width: 100%;\n    height: calc(100% - 30px);\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n    margin-left: 5px;\n    }\n\n\n\n.appPanelsContainerRow {\n  width: 100%;\n  height: 100%;\n  \n  overflow: hidden;\n  }\n\n\n  .appBlockContainer {\n    font-size: 12px;\n    background-color: transparent;\n    width: 100%;\n    \n  }\n\n  .appPanel {\n    display: flex;\n    flex-direction: column;\n  }\n\n  .appPanelBorder {\n    display: flex;\n    flex-direction: column;\n    border-color: var(--panel-color-border);\n    border-width: var(--panel-width-border);\n    border-radius: 8px;\n    border-style: solid;\n    margin: 10px;\n    background-color: var(--panel-color-background-default);\n    }\n\n\n  .ResizeHandleOuter {\n    flex: 0 0 0.2em;\n    position: relative;\n    outline: none;\n  \n    --background-color: transparent;\n  }\n  .ResizeHandleOuter[data-resize-handle-active] {\n    --background-color: var(--color-solid-resize-bar-handle);\n  }\n  \n  .ResizeHandleInner {\n    position: absolute;\n    top: 0.25em;\n    bottom: 0.25em;\n    left: 0.25em;\n    right: 0.25em;\n    border-radius: 0.25em;\n    background-color: white;\n    transition: background-color 0.2s linear;\n  }\n  \n  .apptitleexport\n  {\n    background-color: #000050;\n    padding-bottom: 8px;\n    color: white;\n    margin-bottom: 10px;\n  }\n\n\n  .apptitletimeline\n  {\n    font-size: 10px;\n    font-weight: bold;\n    padding-left: 8px;\n    padding-right: 8px;\n    border-radius: 3px;\n    color: black;\n    background-color: var(--default-icon-color);\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"appDiv": `styles_appDiv__b3idb`,
	"appDivTop": `styles_appDivTop__eAbwf`,
	"appDivLogoFtva": `styles_appDivLogoFtva__9jDiS`,
	"appDivLanguage": `styles_appDivLanguage__xY3if`,
	"appDivLogo": `styles_appDivLogo__H44DO`,
	"appDivProject": `styles_appDivProject__NCHS7`,
	"appDivProjectLeft": `styles_appDivProjectLeft__icS3-`,
	"appDivProjectRight": `styles_appDivProjectRight__MvNW8`,
	"appDivUser": `styles_appDivUser__PE-Wr`,
	"appDivToolsBar": `styles_appDivToolsBar__QVBWe`,
	"appDivBody": `styles_appDivBody__YoBDR`,
	"appPanelsContainer": `styles_appPanelsContainer__68vyI`,
	"appPanelsContainerExport": `styles_appPanelsContainerExport__63o3T`,
	"appPanelsContainerRow": `styles_appPanelsContainerRow__MYVft`,
	"appBlockContainer": `styles_appBlockContainer__KEOyW`,
	"appPanel": `styles_appPanel__Sn+bQ`,
	"appPanelBorder": `styles_appPanelBorder__NR8hr`,
	"ResizeHandleOuter": `styles_ResizeHandleOuter__KzoO5`,
	"ResizeHandleInner": `styles_ResizeHandleInner__LZCFZ`,
	"apptitleexport": `styles_apptitleexport__KPTWq`,
	"apptitletimeline": `styles_apptitletimeline__Ad8sO`
};
export default ___CSS_LOADER_EXPORT___;
